export const CLUB_LIFE_CATEGORIES = [
  { id: "all", label: "Все", icon: "✨" },
  { id: "achievement", label: "Достижения", icon: "🏆" },
  { id: "event", label: "События", icon: "📸" },
  { id: "announcement", label: "Объявления", icon: "📢" },
  { id: "greeting", label: "Поздравления", icon: "🎉" },
  { id: "tip", label: "Советы", icon: "📝" },
];

export function clubLifeCategoryMeta(id) {
  return (
    CLUB_LIFE_CATEGORIES.find((c) => c.id === id) || {
      id,
      label: id,
      icon: "📌",
    }
  );
}
